import { createAction, props } from '@ngrx/store';

export const setGatewaySessionTokenAction = createAction('[Session Token] Set Gateway Session Token', props<{ token: string }>());
